/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_Error_AuthorizeInputs */



/**
* | output |
* | --- |
* | "Authorization failed." |
*
* @param {Oauth_Error_AuthorizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_error_authorize = /** @type {((inputs?: Oauth_Error_AuthorizeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Error_AuthorizeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisation échouée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Autorización fallida.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Autorização falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizzazione fallita.")
	return /** @type {LocalizedString} */ ("Authorization failed.")
});